import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import { Provider } from 'react-redux'
import {store} from './store'
// import App1 from './App1';
// import AnimatedCircle from './AnimateCircle';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
    <App />
    </Provider>
);
